import React, { ReactElement } from "react";
import AddGlobalProduct from "../../components/GlobalProducts/AddProduct";
import Layout from '../../components/layout';
import AddProduct from "../../components/products/AddProduct";

const GlobalProductAddPage = (): ReactElement => {
  return (
    <Layout>
      <AddGlobalProduct />
    </Layout>
  );
};

export default GlobalProductAddPage;
